// This file is generated by a script. Do not edit this file directly.
import React from 'react';
import { Base } from "./Base";
var SIZE_MAP = {
  xs: 'xs',
  sm: 'sm',
  base: 'base',
  lg: 'lg',
  xl: 'xl',
  '2xl': '2xl',
  '3xl': '3xl',
  '4xl': '4xl'
};
var LEADING_CLASSNAMES = {
  xs: '050',
  sm: '075',
  base: '1',
  lg: '2',
  xl: '3',
  '2xl': '4',
  '3xl': '5',
  '4xl': '6'
};
export function Heading(_ref) {
  var children = _ref.children,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$tag = _ref.tag,
    tag = _ref$tag === void 0 ? 'h1' : _ref$tag,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'base' : _ref$size;
  return /*#__PURE__*/React.createElement(Base, {
    className: className,
    size: SIZE_MAP[size],
    variant: "body",
    tag: tag,
    leading: LEADING_CLASSNAMES[size],
    weight: "medium",
    "data-typography": "heading"
  }, children);
}
